import React from "react";
import CertificateFooter from "./CertificateFooter";

const formatSlashDate = (value) => {
  if (!value) return "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const [y, m, d] = value.split("-");
  return `${d}-${m}-${y}`;
};

/**
 * Letter portrait preview for the Lifting Accessories Register.
 * Shared header / sign-off / disclaimer / footer.
 */
const LiftingAccessoriesDocument = ({ doc }) => {
  if (!doc) return null;
  const assetsBase = doc.assetsBase || "";
  const logos = doc.footerLogos || [];
  const rows = Array.isArray(doc.accessory_rows) ? doc.accessory_rows : [];

  return (
    <div className="cc-pdf-page cc-lift-page">
      <div className="cc-pdf-header">
        <img className="cc-pdf-logo" src={`${assetsBase}/logo.jpg`} alt="TUV PAK" />
        <div className="cc-pdf-header-text">
          <strong>TUV PAK INSPEC</strong>
          <span>TECHANICAL UNIQUE VISION PAKISTAN INSPECTION &amp; CERTIFICATION</span>
        </div>
      </div>
      <img className="cc-pdf-rule" src={`${assetsBase}/header-bar.png`} alt="" />

      <h4 className="cc-lift-title">{doc.report_title || "LIFTING ACCESSORIES REGISTER"}</h4>

      <p className="cc-lift-client"><b>Client:</b> {doc.client}</p>
      <div className="cc-lift-meta">
        <div><b>Certificate No:</b> {doc.report_no}</div>
        <div><b>Job No:</b> {doc.job_no}</div>
        <div><b>Place of Inspection:</b> {doc.place_of_inspection}</div>
        <div><b>Standard/Specification:</b> {doc.standard_specification}</div>
        <div><b>Registration No:</b> {doc.registration_no}</div>
      </div>

      <div className="cc-lift-band">SUMMARY OF INSPECTION</div>
      <table className="cc-lift-table">
        <thead>
          <tr>
            <th>S. No</th>
            <th>Description</th>
            <th>WLL Or SWL</th>
            <th>Date of this through Examination</th>
            <th>Date of Next through Examination</th>
            <th>Type of Inspection</th>
            <th>Identification of Item/Tag No:</th>
            <th>Qty.</th>
            <th>Safe to Use Yes or No</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{row.description}</td>
              <td>{row.wll_swl}</td>
              <td>{formatSlashDate(row.date_of_examination)}</td>
              <td>{formatSlashDate(row.date_of_next_examination)}</td>
              <td>{row.type_of_inspection}</td>
              <td>{row.identification}</td>
              <td>{row.qty}</td>
              <td>{row.safe_to_use}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="cc-lift-line">
        <b>INSPECTION STANDARD:</b> {doc.inspection_standard}
      </p>
      <p className="cc-lift-line">
        <b>CONCLUSION &amp; REMARKS:</b> {doc.conclusion_remarks}
      </p>
      <p className="cc-lift-line">
        <b>REMARKS:</b> {doc.remarks}
      </p>

      <table className="cc-pdf-sign">
        <thead>
          <tr>
            <th>Inspected By</th>
            <th>Approved By</th>
            <th>Company Seal</th>
            <th>QR Code</th>
          </tr>
        </thead>
        <tbody>
          <tr className="cc-pdf-sign-names">
            <td>{doc.inspected_by_name}</td>
            <td>{doc.approved_by_name}</td>
            <td rowSpan={2} className="cc-pdf-sign-seal">
              {doc.sealUrl && <img src={doc.sealUrl} alt="Company seal" />}
            </td>
            <td rowSpan={2} className="cc-pdf-sign-qr">
              {doc.qrDataUrl && <img src={doc.qrDataUrl} alt="QR code" />}
            </td>
          </tr>
          <tr className="cc-pdf-sign-images">
            <td>{doc.inspectedSignatureUrl && <img src={doc.inspectedSignatureUrl} alt="Inspector signature" />}</td>
            <td>{doc.approvedSignatureUrl && <img src={doc.approvedSignatureUrl} alt="Approver signature" />}</td>
          </tr>
        </tbody>
      </table>

      <div className="cc-pdf-disclaimer">
        <p>{doc.disclaimer_text}</p>
        <b>{doc.end_of_report_text}</b>
      </div>

      <CertificateFooter
        assetsBase={assetsBase}
        logos={logos}
        website={doc.footer_website}
        email={doc.footer_email}
        gmail={doc.footer_gmail}
      />
    </div>
  );
};

export default LiftingAccessoriesDocument;
